// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"Frame_iframeContainer__qdvgT"};